<header class="topbar">
  <div class="topbar-left">
    <div class="brand">FlwX</div>
  </div>

  <nav class="topbar-nav">
    @if (isSuperAdmin() || isCompanyAdmin()) {
      <a
        routerLink="/app/dashboard"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        >Dashboard</a
      >
      <a routerLink="/app/users" routerLinkActive="active">Users</a>
    }

    @if (isSuperAdmin()) {
      <a routerLink="/app/companies" routerLinkActive="active">Companies</a>
    }

    <a routerLink="/app/jobs" routerLinkActive="active">Jobs</a>

    @if (isSuperAdmin()) {
      <a routerLink="/app/smart-cull" routerLinkActive="active">Smart Cull</a>
      <a routerLink="/app/sales-reports" routerLinkActive="active">Sales Reports</a>
      <a routerLink="/app/ai-presets" routerLinkActive="active">AI Presets</a>
      <a routerLink="/app/preset-categories" routerLinkActive="active">Preset Categories</a>
    }
  </nav>

  <div class="topbar-right">
    @if (isSuperAdmin()) {
      <div class="company-dropdown" (click)="onDropdownClick($event)">
        <button type="button" class="company-dropdown-trigger" (click)="toggleCompanyDropdown()">
          <span class="company-dropdown-text">{{ selectedCompanyName() }}</span>
          <span class="company-dropdown-arrow">▾</span>
        </button>

        @if (isCompanyDropdownOpen()) {
          <div class="company-dropdown-menu">
            @for (company of companies(); track company.id) {
              <button
                type="button"
                class="company-dropdown-item"
                [class.selected]="company.id === selectedCompanyId()"
                (click)="selectCompany(company)"
              >
                {{ company.name }}
              </button>
            }
          </div>
        }
      </div>
    }

    <div class="topbar-actions">
      <div class="company-dropdown user-settings-dropdown" (click)="onDropdownClick($event)">
        <button type="button" class="company-dropdown-trigger" (click)="toggleUserDropdown()">
          <span class="company-dropdown-text">{{ userFullName() }}</span>
          <span class="company-dropdown-arrow">▾</span>
        </button>

        @if (isUserDropdownOpen()) {
          <div class="company-dropdown-menu" style="width: 180px;">
            <button type="button" class="company-dropdown-item" (click)="openChangePasswordModal()">Change Password</button>
            <button type="button" class="company-dropdown-item" style="color: #dc2626;" (click)="openLogoutModal()">Logout</button>
          </div>
        }
      </div>
    </div>
  </div>
</header>

<main class="private-page-content">
  <router-outlet></router-outlet>
</main>

@if (isLogoutModalOpen()) {
  <div class="modal-overlay" (click)="closeLogoutModal()">
    <div class="logout-modal" (click)="$event.stopPropagation()">
      <div class="logout-modal-header">
        <h3>Logout</h3>
        <button type="button" class="modal-close-btn" (click)="closeLogoutModal()">×</button>
      </div>

      <div class="logout-modal-body">
        <p>Are you sure you want to logout from the system?</p>
      </div>

      <div class="logout-modal-actions">
        <button type="button" class="logout-cancel-btn" (click)="closeLogoutModal()">Cancel</button>
        <button type="button" class="logout-confirm-btn" (click)="confirmLogout()">Logout</button>
      </div>
    </div>
  </div>
}

@if (isChangePasswordModalOpen()) {
  <div class="modal-overlay" (click)="closeChangePasswordModal()">
    <div class="logout-modal" (click)="$event.stopPropagation()" style="max-width: 450px;">
      <div class="logout-modal-header">
        <h3>Change Password</h3>
        <button type="button" class="modal-close-btn" (click)="closeChangePasswordModal()">×</button>
      </div>

      <div class="logout-modal-body" style="padding-top: 20px;">
        <form [formGroup]="passwordForm" (ngSubmit)="onChangePasswordSubmit()">
          @if (passwordError) {
            <div style="background: #fef2f2; color: #ef4444; padding: 10px; border-radius: 8px; margin-bottom: 15px; font-size: 0.9rem;">
              {{ passwordError }}
            </div>
          }
          @if (passwordSuccess) {
            <div style="background: #f0fdf4; color: #16a34a; padding: 10px; border-radius: 8px; margin-bottom: 15px; font-size: 0.9rem;">
              {{ passwordSuccess }}
            </div>
          }

          <div style="margin-bottom: 15px;">
            <label style="display: block; font-size: 0.9rem; font-weight: 500; margin-bottom: 6px; color: #374151;">Current Password</label>
            <input type="password" formControlName="currentPassword" style="width: 100%; padding: 10px; border: 1px solid #dbe2ea; border-radius: 8px;" />
            @if (passwordForm.get('currentPassword')?.touched && passwordForm.get('currentPassword')?.invalid) {
              <div style="color: #ef4444; font-size: 0.8rem; margin-top: 4px;">Required</div>
            }
          </div>

          <div style="margin-bottom: 15px;">
            <label style="display: block; font-size: 0.9rem; font-weight: 500; margin-bottom: 6px; color: #374151;">New Password</label>
            <input type="password" formControlName="newPassword" style="width: 100%; padding: 10px; border: 1px solid #dbe2ea; border-radius: 8px;" />
            @if (passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid) {
              <div style="color: #ef4444; font-size: 0.8rem; margin-top: 4px;">Required (min 6 chars)</div>
            }
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 0.9rem; font-weight: 500; margin-bottom: 6px; color: #374151;">Confirm New Password</label>
            <input type="password" formControlName="confirmNewPassword" style="width: 100%; padding: 10px; border: 1px solid #dbe2ea; border-radius: 8px;" />
            @if (passwordForm.get('confirmNewPassword')?.touched && passwordForm.get('confirmNewPassword')?.invalid) {
              <div style="color: #ef4444; font-size: 0.8rem; margin-top: 4px;">Required</div>
            }
            @if (passwordForm.get('confirmNewPassword')?.touched && passwordForm.hasError('mismatch')) {
              <div style="color: #ef4444; font-size: 0.8rem; margin-top: 4px;">Passwords do not match</div>
            }
          </div>

          <div class="logout-modal-actions" style="padding: 0;">
            <button type="button" class="logout-cancel-btn" (click)="closeChangePasswordModal()">Cancel</button>
            <button type="submit" class="logout-confirm-btn" style="background: #0f172a; border-color: #0f172a;" [disabled]="passwordForm.invalid || isChangingPassword">
              {{ isChangingPassword ? 'Saving...' : 'Save Password' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
